/**
 * 小游戏抽奖方式
 * @author honggexuan
 * @since 19/03/19
 */

import { SET_LOTTERY_INFO, SHOW_TIPS } from 'constants/action.json5';

// 默认无抽奖 -1
const DEAFULT_LOTTERYID = -1;

const initState = {
  lotteryId: DEAFULT_LOTTERYID,
  showTips: {
    // 默认不展示体验价格
    showFreePrice: false,
    // 提示当前身份是否处于体验中
    showIsExperience: false,
    // 是否有体验资格
    haveRightTrial: true,
  },
};

export default function(state = initState, action) {
  const newState = { ...state };
  switch (action.type) {
    case SET_LOTTERY_INFO:
      newState.lotteryId = action.payload;
      return newState;
    case SHOW_TIPS:
      newState.showTips = action.payload;
      return newState;
    default:
      return newState;
  }
}
